var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"map"},[_c('iframe',{ref:"mapIframe",attrs:{"width":"100%","height":"800px","frameborder":"0","src":"https://m.amap.com/picker/?key=bb7409257967da9aab704f474a48f504&jscode=e3dd11d125bdf105cac127732188c745"},on:{"load":_vm.loaded}})])
}
var staticRenderFns = []

export { render, staticRenderFns }